import { memo } from 'react';

import { Banner } from '@air/primitive-banner';

type UploadDisabledOnPageWarningProps = {
  title: string;
  message: string;
};

export const UploadDisabledOnPageWarning = memo(({ message, title }: UploadDisabledOnPageWarningProps) => (
  <Banner appearance="warning">
    <p className="font-medium">{title}</p>
    <p>{message}</p>
  </Banner>
));

UploadDisabledOnPageWarning.displayName = 'UploadDisabledOnPageWarning';
